exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#heading {\n    text-align: center;\n}\n\nform\n{\n    padding: 20px;\n    margin: auto;\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/ocr/ocr.component.css
// module id = ../../../../../src/app/ocr/ocr.component.css
// module chunks = 0